import { OrderID } from 'framework/orders'
import { EcommerceService } from 'services'
import { CustomerService } from 'modules/customers/services'
import type {
  CreateOrderFail,
  CreateOrderSuccess,
  Order,
  OrderItems,
  OrderShippingTotal,
} from 'modules/orders/services'
import { useMercadinho } from 'hooks/use-mercadinho'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'

export default class OrderService extends EcommerceService {
  private order: Order = {} as unknown as Order

  private items: OrderItems = []

  private shipping: OrderShippingTotal = 0

  private customerService: CustomerService

  constructor(customerService: CustomerService) {
    super()
    this.customerService = customerService
  }

  setOrderId(id: OrderID) {
    this.order = {
      ...this.order,
      id,
    }
  }

  setOrder(order: Order) {
    this.order = order
    return this
  }

  getOrder(): Order {
    return this.order
  }

  setItems(items: any[], subscription: boolean = false, exp: boolean = false, conventional: boolean = false): OrderService {
    if (subscription) {
      this.items = items.filter((x) => x.assinatura)
      return this
    }
    if (exp) {
      this.items = items.filter((x) => x.experiencia_id)
      return this
    }
    if(conventional) {
      this.items = items.filter((x) => !(x.experiencia_id) && !x.assinatura)
      return this
    }
    this.items = items
    return this
  }

  getItems() {
    return this.items
  }

  enableMercadinho(mercadinhoID: number) {
    this.setMercadinho(true, mercadinhoID)
  }

  setShipping(shipping: number): OrderService {
    this.shipping = shipping
    return this
  }

  getShipping() {
    return this.shipping
  }

  create({ note, partnerRef, local_pickup = false, shippingTotal }: { note: string; partnerRef: string, local_pickup: boolean, shippingTotal: number }) {
    const { id } = this.customerService.getCustomer()
    const payload = {
      customer_id: id,
      partner_ref: partnerRef,
      local_pickup: local_pickup,
      items: this.getItems().map((item) => {
        if (item.experiencia_id) {
          return {
            product_id: item.id,
            product_experience_id: item.experiencia_id,
            delivery_method: "retirada-local",
            quantity: item.quantity,
            subscription: item.assinatura,
            discount: 0,
          }
        }

        return {
          product_id: item.id,
          quantity: item.quantity,
          period: item.period,
          subscription: item.assinatura,
          discount: item.assinatura ? item.assinatura_desconto_produtor : 0,
          delivery_method: item.delivery_method,
        }
      }),
      total_shipping: shippingTotal,
      comment: note,
    }

    if (!local_pickup) {
      this.setMercadinho(false)
    }

    const isMercadinho: boolean = JSON.parse(localStorage.getItem("mercadinho-config") as string).isMercadinho;

    const hasOnlyExpItems = !this.getItems().some((item) => !item.experiencia_id || item.experiencia_id === null)

    if(!isMercadinho) {
      if (payload.items.some((item) => (!item.delivery_method || item.delivery_method === "standard")) && !hasOnlyExpItems) {
        if (typeof window !== 'undefined') {
          const searchParams = new URLSearchParams(window.location.search);

          if(searchParams.get('exp') === "true") searchParams.append('exp', 'true');
          if(searchParams.get('subscription') === "true") searchParams.append('exp', 'true');

          window.location.href = `/carrinho?${searchParams.toString()}`;
        }
        return null;
      }
    }
    
    let url = '/orders';
    const afiliadoId = Cookies.get('afiliadoId');
    if (afiliadoId) {
      url += `?afiliadoId=${afiliadoId}`;
    }
    return this.setUrl(url).post(payload);
  }

  async getOrderById(orderId: OrderID, onSucess: CreateOrderSuccess, onFail: CreateOrderFail): Promise<void> {
    const items: any[] = []
    try {
      const url = `/orders/${orderId}`
      const {
        data: { order },
      } = await this.setUrl(url).get()

      // eslint-disable-next-line array-callback-return
      order.sub_orders.map((orders: any) => {
        orders.order_items.map((item: any) =>
          items.push({
            ...item,
            product: {
              ...item.product,
              seller: {
                ...orders.farmer,
              },
            },
          }),
        )
      })


      const data = { ...order, id: order.id, items }
      this.setOrder(data)
      onSucess(data)
    } catch (e) {
      onFail()
    }
  }

  async updateComment(orderId: OrderID, comment: string) {
    const url = `/orders/${orderId}/comment-update`
    const payload = {
      comment,
    }

    return this.setUrl(url).post(payload)
  }
}
